/**
 * 日本人名データベース
 * シミュレーション用の苗字・名前プール
 */

// ========================================
// 苗字（姓）- 150種類
// ========================================
export const SURNAMES = [
  // 人口ランキング上位50
  '佐藤', '鈴木', '高橋', '田中', '伊藤', '渡辺', '山本', '中村', '小林', '加藤',
  '吉田', '山田', '佐々木', '山口', '松本', '井上', '木村', '林', '斎藤', '清水',
  '森', '池田', '橋本', '山崎', '石川', '前田', '藤田', '後藤', '近藤', '遠藤',
  '青木', '坂本', '福田', '西村', '太田', '岡田', '長谷川', '村上', '石井', '藤井',
  '金子', '中島', '中川', '原', '藤原', '今井', '和田', '野口', '上田', '杉山',

  // 追加の一般的な苗字
  '小川', '浜田', '宮崎', '菊地', '工藤', '岡本', '横山', '川崎', '安藤', '三浦',
  '上野', '柴田', '増田', '内田', '大野', '酒井', '武田', '平野', '千葉', '久保',
  '田村', '河野', '松田', '市川', '矢野', '杉本', '永井', '小野', '堀', '古川',
  '西田', '土屋', '松井', '阿部', '望月', '岩崎', '水野', '関', '秋山', '辻',
  '野田', '本田', '吉川', '菅原', '服部', '片山', '須藤', '野村', '中野', '谷口',

  // 珍しめの苗字
  '神谷', '黒田', '大塚', '新井', '川口', '宮本', '荒木', '五十嵐', '早川', '竹内',
  '松尾', '村田', '飯田', '今野', '平田', '福島', '大谷', '東', '岩田', '丸山',
  '小島', '栗原', '佐野', '原田', '川上', '松浦', '高野', '吉野', '菅野', '樋口',
  '沢田', '広瀬', '川村', '星野', '田口', '渡部', '鎌田', '相田', '織田', '黒木',
  '榎本', '児玉', '永田', '中西', '大西', '桜井', '堺', '島田', '内山', '草野',
];

// ========================================
// 移住者専用の苗字（珍しい・特徴的な苗字）
// ========================================
export const IMMIGRANT_SURNAMES = [
  // 東方系
  '東山', '日向', '朝倉', '旭', '曙', '暁', '東条', '東雲',
  // 西方系
  '西園寺', '夕凪', '宵月', '黄昏', '西条', '夕暮', '西宮', '落合',
  // 南方系
  '南条', '陽炎', '朱雀', '紅葉', '南雲', '日野', '陽向', '炎上',
  // 北方系
  '北条', '氷室', '雪村', '冬木', '北上', '霜月', '冷泉', '白雪',
  // 天体・自然系
  '神崎', '天城', '桜庭', '星野', '月島', '風間', '雲居', '龍崎',
  '鷹司', '九条', '三条', '一条', '二階堂', '六角', '八雲', '七瀬',
  // 地形・場所系
  '滝沢', '瀬戸', '岬', '峰岸', '丘', '磯部', '浦島', '港',
  // 動植物系
  '鳳', '鷲尾', '狐塚', '熊谷', '鶴見', '亀井', '蝶野', '鯉沼',
];

// ========================================
// 男性名（名）- 100種類
// ========================================
export const MALE_FIRST_NAMES = [
  // 伝統的な名前
  '太郎', '次郎', '三郎', '健太', '大輔', '修', '誠', '剛', '隆', '健',
  '浩', '悟', '智', '光', '正', '勝', '茂', '博', '進', '清',

  // 現代的な名前（〜た/〜と系）
  '翔', '蓮', '陽太', '颯太', '颯', '蒼', '海斗', '悠斗', '陸', '樹',
  '大翔', '朝陽', '湊', '蒼空', '奏', '律', '新', '暖', '晴', '結翔',

  // 〜也/〜哉系
  '拓也', '和也', '達也', '哲也', '竜也', '雄也', '直也', '真也', '裕也', '隼也',
  '圭哉', '晃哉', '拓哉', '侑哉', '賢哉',

  // 〜輔/〜介系
  '大輔', '健介', '龍介', '恭介', '慎介', '良介', '陽介', '俊介', '洋介', '涼介',

  // 〜斗系
  '陽斗', '悠斗', '優斗', '隼斗', '直斗', '瑛斗', '結斗', '颯斗', '湊斗',

  // 〜人系
  '悠人', '陽人', '優人', '隼人', '直人', '瑛人', '結人', '拓人', '健人', '雄人',

  // 〜樹/〜希系
  '大樹', '直樹', '和樹', '拓樹', '勇樹', '優樹', '一樹', '雄樹',

  // その他現代名
  '翼', '渉', '航', '亮', '晃', '潤', '涼', '凌', '遼', '陵',
  '響', '駿', '匠', '巧', '司', '慧', '瑛', '怜', '玲', '零',
];

// ========================================
// 女性名（名）- 100種類
// ========================================
export const FEMALE_FIRST_NAMES = [
  // 伝統的な名前
  '花子', '幸子', '和子', '節子', '京子', '恵子', '洋子', '裕子', '真理子', '由美子',

  // 〜美/〜み系
  '美咲', '美優', '美月', '美羽', '美桜', '美紀', '真美', '友美', '由美', '直美',
  '麻美', '亜美', '恵美', '裕美', '智美',

  // 〜菜/〜奈系
  '結菜', '陽菜', '優菜', '彩菜', '愛菜', '瑠菜', '莉菜', '芽菜',
  '瑠奈', '莉奈', '優奈', '愛奈', '彩奈', '杏奈', '沙奈',

  // 〜花/〜華系
  '優花', '彩花', '結花', '愛花', '美花', '桃花', '百花', '風花', '和花', '心花',
  '明華', '優華', '彩華', '愛華', '麗華',

  // 〜子/〜香系
  '莉子', '凛子', '桃子', '杏子', '柚子',
  '穂乃香', '百合香', '由里香', '美里香', '茉莉香', '優香', '瑞香', '風香',

  // 自然・植物系
  '葵', 'さくら', '桜', '楓', '杏', '柚', '桃', '椿', '梓', '茜',
  '菫', '藍', '蓮', '芹', '萌', '芽生', '咲', '実', '菜々', '若葉',

  // 現代的な名前
  '愛', '結衣', '凛', '七海', '咲良', '心春', '陽葵', '芽依', '詩織', '千尋',
  '舞', '綾', '遥', '彩', '麗', '澪', '琴', '紬', '鈴', '雫',
];

// ========================================
// 中性的な名前（どちらでも使える）
// ========================================
export const NEUTRAL_FIRST_NAMES = [
  '光', '薫', '遥', '純', '翠', '碧', '晶', '潤', '涼', '凪',
  '空', '海', '響', '奏', '律', '真', '誠', '優', '慧', '瑞',
];

// ========================================
// 名前の組み合わせ数計算
// ========================================
export const NAME_POOL_SIZE = {
  surnames: SURNAMES.length,
  immigrantSurnames: IMMIGRANT_SURNAMES.length,
  maleFirstNames: MALE_FIRST_NAMES.length,
  femaleFirstNames: FEMALE_FIRST_NAMES.length,
  neutralFirstNames: NEUTRAL_FIRST_NAMES.length,
  totalSurnames: SURNAMES.length + IMMIGRANT_SURNAMES.length,
  totalFirstNames: MALE_FIRST_NAMES.length + FEMALE_FIRST_NAMES.length + NEUTRAL_FIRST_NAMES.length,
  // 最大ユニーク組み合わせ数 (苗字 × 名前)
  get maxCombinations() {
    return this.totalSurnames * this.totalFirstNames;
  },
};
